<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <div class="filter-box">
          <span class="label">用户名字</span>
          <el-input
            v-model="listQuery.name"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">用户工号</span>
          <el-input
            v-model="listQuery.username"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">手机号</span>
          <el-input
            v-model="listQuery.phone"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
          />
        </div>
        <div class="filter-box">
          <span class="label">性别</span>
          <el-select :filterable="true" v-model="listQuery.sex" class="filter-item" placeholder="" :size="t('table.btnSize')" @change="handleFilter">
            <el-option
              v-for="item in SexOption"
              :key="item.id"
              :label="item.mark"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="filter-box">
          <span class="label">入职日期</span>
          <el-date-picker
            v-model="listQuery.date"
            type="daterange"
            range-separator="-"
            start-placeholder=" "
            end-placeholder=" "
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            :size="t('table.btnSize')"
            change="handleFilter"
          >
          </el-date-picker>
        </div>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
              <i class="icon-tubiao-27 iconfont"/>
            </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
              <i class="icon-tubiao-28 iconfont"/>
            </span>
        </div>
      </div>
      <TableList
        ref="tableListRef"
        v-loading="listLoading"
        :dataList="list"
        :total="total"
        :columnAllData="columnAllData"
        :page="listQuery.page"
        :size="listQuery.size"
        :tableName="TableName.TABLE_USER"
        :permissionName="permissionName"
        @command-change="handleCommand"
        :canRefresh="false"
        :canChangeColumn="false"
        :highlightCurrentRow="true"
      >
        <template v-slot:operation-action="scope">
          <el-link
            v-permission="{ pkey: `${permissionName}_EDIT` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit', scope.row)"
          >
            {{ t("table.edit") }}
          </el-link>
          <el-link
            v-permission="{ pkey: `${permissionName}_DELETE` }"
            href="javascript:void(0);"
            type="danger"
            @click="handleCommand('delete', scope.row)"
          >
            {{ t("table.delete") }}
          </el-link>
        </template>
      </TableList>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :handleResolveTempData="handleResolveTempData"
      :api="'user'"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getUserDetailByUserId, deleteUserById, defaultUsersModel, getUserList, availableSuperUser } from '@/apis/user'

import { UsersModel } from '@/model/userModel'
import { ArrayRowsItem } from '@/model/Index'

import { getDropdownByType, DropdownOptionModel, DropdownType } from '@/apis/tool'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField } from './FieldTable'
import dayjs from 'dayjs'

import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'User',
  components: {
    FormComponent,
    TableList
  },
  setup() {
    const { t } = useI18n()
    const tableListRef = ref(null)
    const dataMap = reactive({
      TableName,
      permissionName: permissionName.USER,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      columnAllData: TableField,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        username: undefined,
        sex: undefined,
        phone: undefined,
        date: [],
        entryDateMin: '',
        entryDateMax: '',
        page: 1,
        size: 20
      },
      superId: 0,
      deptTop: {
        id: 0,
        name: '顶级'
      },
      dialogFormVisible: false,
      tempModel: defaultUsersModel,
      SexOption: [],

      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef?.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getUserList(dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          username: undefined,
          sex: undefined,
          phone: undefined,
          date: [],
          entryDateMin: '',
          entryDateMax: '',
          page: 1,
          size: 20
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        if (dataMap.listQuery.date && dataMap.listQuery.date.length) {
          dataMap.listQuery.entryDateMin = dayjs(dataMap.listQuery.date[0]).format('YYYY-MM-DD')
          dataMap.listQuery.entryDateMax = dayjs(dataMap.listQuery.date[1]).format('YYYY-MM-DD')
        } else {
          dataMap.listQuery.entryDateMin = ''
          dataMap.listQuery.entryDateMax = ''
        }
        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)

        getUserDetailByUserId(row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                field.value = res[field.fieldKey] || field.value
                switch (field.fieldKey) {
                  case 'livePlace':
                    field.value = res.livePlace ? res.livePlace.split('-') : ''
                    break
                  case 'registerPlace':
                    field.value = res.registerPlace ? res.registerPlace.split('-') : ''
                    break
                  case 'superId':
                    if (!field.value) {
                      field.option = [dataMap.deptTop]
                    }
                    break
                }
              })
            } else if (k.type === 2) {
              const _arr = [] as ArrayRowsItem
              const addContions = dataMap.initFormData.find((j: any) => j.title === '工资卡')?.formList
              if (addContions) {
                res.userPays.forEach((item: any) => {
                  const _copyContion = cloneDeep(addContions)[0]
                  _copyContion.id = item.id
                  Object.keys(item).forEach(k => {
                    _copyContion.list?.forEach((j: any) => {
                      if (j.fieldKey === k) {
                        j.value = item[k] || j.value
                      }
                    })
                  })
                  _arr.push(_copyContion)
                })
                k.formList = _arr
              }
            }
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            cancelButtonClass: 'el-button--danger',
            type: 'warning'
          }
        )
          .then(() => {
            deleteUserById(row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleResolveTempData(tempModel: any) {
        const { deptIds, payList, livePlace, registerPlace, deleteList } = tempModel
        tempModel.deptIds = deptIds ? deptIds.flat() : []
        if (payList && payList.length) {
          tempModel.createPays = payList.filter((k: any) => !k.id)
          tempModel.updatePays = payList.filter((k: any) => k.id)
        }
        tempModel.deletePays = deleteList
        tempModel.registerPlace = registerPlace ? registerPlace.join('-') : ''
        tempModel.livePlace = livePlace ? livePlace.join('-') : ''
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList(type: DropdownType) {
        getDropdownByType(type).then((res: any) => {
          dataMap[`${type}Option`] = res
        })
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 1 && column.url) {
            getDropdownByType(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
          if (column.fieldKey === 'superId') {
            availableSuperUser().then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
        })
      }
    })
    onMounted(() => {
      dataMap.loadTableSelectOption()
      dataMap.getList()
      dataMap.getDropdownList('Sex')
    })
    return { t, ...toRefs(dataMap), tableListRef }
  }
})
</script>
<style lang="scss">

</style>
